export default "__VITE_ASSET__CvSgH6ov__"